// extracted by mini-css-extract-plugin
export default {"switch-btn__container":"styles_switch-btn__container__7Kfmk","switch-btn":"styles_switch-btn__uPAyf"};